import Apollo from "apollo-client";
import { createUploadLink } from "./apollo-upload";
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";
import introspectionQueryResultData from "application/apollo/fragmentTypes.json";
import { split } from "ramda";
import { prod } from "application/constants/app-constants";

const getHost = () => {
  if (!prod) {
    return "https://sscc-pre.central.inditex.grp/inetgeco/graphql";
  } else {
    const splittedUrl = split("/inetgeco/", window.location.href);
    return `${splittedUrl[0]}/inetgeco/graphql`;
  }
};

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const link = createUploadLink({
  uri: getHost(),
  credentials: "include",
});

const apolloClient = new Apollo({
  cache: new InMemoryCache({ fragmentMatcher }),
  link,
});

export default apolloClient;
